import { gql } from '@apollo/client';

export const CREATE_PAGE = gql`
  mutation createPage(
    $siteDomain: String!
    $title: String!
    $content: String!
    $template: EPageTemplate!
  ) {
    createPage(
      input: {
        siteDomain: $siteDomain
        title: $title
        content: $content
        template: $template
      }
    ) {
      siteDomain
      title
      content
      template
      slug
    }
  }
`;

export const UPDATE_PAGE = gql`
  mutation updatePage(
    $id: String!
    $siteDomain: String!
    $title: String!
    $content: String!
    $template: EPageTemplate!
  ) {
    updatePage(
      id: $id
      input: {
        siteDomain: $siteDomain
        title: $title
        content: $content
        template: $template
      }
    ) {
      siteDomain
      title
      content
      template
      slug
    }
  }
`;

export const GET_PAGES = gql`
  query listPages($siteDomains: [String!]) {
    listPages(siteDomains: $siteDomains) {
      id
      siteDomain
      title
      content
      template
      slug
    }
  }
`;

export const DELETE_PAGE = gql`
  mutation deletePage($id: String!) {
    deletePage(id: $id) {
      id
      siteDomain
      title
      content
      template
      slug
    }
  }
`;

export const PUBLISH_PAGE_TO_FALCON = gql`
  mutation publishPageToFalcon($id: String!) {
    publishPageToFalcon(id: $id)
  }
`;
